import { JwtPayload, jwtDecode } from "jwt-decode";
import { AuthState, getToken } from "redux/authSlice";

export const prepareHeaders = (headers: any, { getState }: any) => {
  try {
    const state = getState() as {
      isAuthenticated: boolean;
      user: null; auth: AuthState
    }; // Specify the type of state
    const token = getToken(state);
    headers.set('subdomain', 'api');
    headers.set('authorization', `Bearer ${token}`);
  } catch (error) {
    console.error('Error preparing headers:', error);
  }
  return headers;
}

// export const externalPrepareHeaders = (headers: any, { getState }: any) => {
//   try {
//     const state = getState() as {
//       isAuthenticated: boolean;
//       user: null; auth: AuthState
//     }; // Specify the type of state
//     const token = getToken(state);
//     headers.set('subdomain', 'api');
//     headers.set('authorization', `Bearer ${token}`);
//   } catch (error) {
//     console.error('Error preparing headers:', error);
//   }
//   return headers;
// }
export const externalPrepareHeaders = (headers: Headers, { getState, endpointArgs }: any) => {
  try {
    const state = getState() as { auth: AuthState };
    const token = getToken(state);

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    // Use subdomain passed from mutation, if any
    if (endpointArgs?.subdomain) {
      headers.set('subdomain', endpointArgs.subdomain);
    }
  } catch (error) {
    console.error('Error preparing headers:', error);
  }
  return headers;
};


// ***************************************************BREAK***************************************************
  // const isTokenExpired = (token: string) => {
  //   const decodedToken: JwtPayload = jwtDecode(token);
  //   const currentTimestamp = Math.floor(Date.now() / 1000);
  //   return decodedToken.exp !== undefined ? decodedToken.exp < currentTimestamp : currentTimestamp;
  // };
  
  // const refreshPage = () => {
  //   window.location.reload();
  // }

// import { JwtPayload, jwtDecode } from "jwt-decode";
// import { AuthState, getToken } from "redux/authSlice";

// interface State {
//   isAuthenticated: boolean;
//   user: null;
//   auth: AuthState;
// }

// const AUTHORIZATION_HEADER = 'authorization';
// const SUBDOMAIN_HEADER = 'subdomain';

// export const prepareHeaders = (headers: Headers, getState: () => State): Headers => {
//   try {
//     const state = getState();
//     const token = getToken(state);
    
//     headers.set(SUBDOMAIN_HEADER, 'localhost');
    
//     if (token && !isTokenExpired(token)) {
//       headers.set(AUTHORIZATION_HEADER, `Bearer ${token}`);
//     } else {
//       localStorage.removeItem('userData');
//       refreshPage();
//     }
//   } catch (error) {
//     console.error('Error preparing headers:', error);
//   }

//   return headers;
// };

// const isTokenExpired = (token: string): boolean => {
//   const decodedToken: JwtPayload = jwtDecode(token);
//   const currentTimestamp = Math.floor(Date.now() / 1000);
//   return decodedToken.exp !== undefined ? decodedToken.exp < currentTimestamp : false;
// };

// const refreshPage = (): void => {
//   window.location.reload();
// };
